<form [formGroup]="form" class="d-flex flex-wrap">
    <div class="col-12 d-flex justify-content-between align-items-center">
        <p class="mb-2 text-bold">{{title}}</p>
        <i class="fas fa-times cursor-pointer" matTooltip="Eliminar remesa"
            *ngIf="canEditConsignmentServiceModule && canDeleteConsignment" (click)="removeConsignmentForm.emit()"></i>
    </div>
    <div class="col-12 alert alert-danger text-center text-bold" role="alert" *ngIf="form.get('errorCreation')?.value || form.get('errorInitialFulfillment')?.value 
        || form.get('errorFinalFulfillment')?.value || form.get('errorCancellation')?.value">
        {{form.get('errorCreation')?.value
        ? form.get('errorCreation')?.value :
        form.get('errorInitialFulfillment')?.value
        ? form.get('errorInitialFulfillment')?.value :
        form.get('errorFinalFulfillment')?.value
        ? form.get('errorFinalFulfillment')?.value :
        form.get('errorCancellation')?.value
        ? form.get('errorCancellation')?.value : ''}}
    </div>
    <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Nombre del propietario <span class="asterisk">*</span></mat-label>
        <input matInput [formControl]="internalForm.get('cargoOwnerNameControl')">
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-3">
        <mat-label>Documento del propietario <span class="asterisk">*</span></mat-label>
        <input matInput [formControl]="internalForm.get('cargoOwnerDocumentControl')">
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-3">
        <mat-label>Código de sede <span class="asterisk">*</span></mat-label>
        <input matInput [formControl]="internalForm.get('cargoOwnerBranchOfficeControl')">
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Tipo de remesa <span class="asterisk">*</span></mat-label>
        <mat-select [formControl]="internalForm.get('operationTypeControl')" [compareWith]="compareByCode"
            (selectionChange)="onChangeOperationType($event.value)">
            <mat-option *ngFor="let option of filteredConsignmentTypeOptions" [value]="option">
                <i matPrefix class="fas fa-info-circle color-secondary-dark cursor-pointer"
                    [matTooltip]="option.tooltip" matTooltipClass="tooltip__alert" matTooltipPosition="left"></i>
                {{ option.description }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="internalForm.get('operationTypeControl')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="consignmentManager.consignmentRequiresConsolidationType(form.getRawValue())"
        appearance="outline" class="col-md-6">
        <mat-label>Tipo de consolidación <span class="asterisk">*</span></mat-label>
        <mat-select [formControl]="internalForm.get('consolidationTypeControl')" [compareWith]="compareById"
            (selectionChange)="onChangeConsolidationType($event.value)">
            <mat-option *ngFor="let option of consolidationTypeOptions" [value]="option">
                {{ option.name }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="internalForm.get('consolidationTypeControl')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Naturaleza de la carga <span class="asterisk">*</span></mat-label>
        <mat-select [formControl]="internalForm.get('cargoNatureControl')" [compareWith]="compareByCode"
            (selectionChange)="onChangeCargoNature($event.value)">
            <mat-option *ngFor="let option of cargoNatureTypeOptions" [value]="option"
                [disabled]="disableNatureType(option)">
                {{ option.description }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="internalForm.get('cargoNatureControl')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Tipo de empaque<span class="asterisk">*</span></mat-label>
        <mat-select [formControl]="internalForm.get('packagingTypeControl')"
            (selectionChange)="onChangePackagingType($event.value)">
            <mat-option *ngFor="let packagingType of filteredPackagingTypeOptions" [value]="packagingType">
                {{ packagingType.description }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="internalForm.get('packagingTypeControl')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
    </mat-form-field>
    <app-cargo-type-merchandise [inputFormControl]="internalForm.get('merchandiseControl')"
        [options]="{ appearance: 'outline', initialValue: initialValues.merchandiseDescription }"
        [validate]="hasEntryId() ? 'disable' : formValidate" class="col-md-6">
    </app-cargo-type-merchandise>
    <mat-form-field appearance="outline" class="col-md-12" *ngIf="isContainerService">
        <mat-label>N° de contenedor <span class="asterisk">*</span></mat-label>
        <input matInput type="text" [formControl]="form.get('container')" angularFormsMask="CCCCDDDDDDD"
            containerNumber>
        <mat-error *ngIf="form.get('container')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
        <mat-error *ngIf="form.get('container')?.errors?.pattern">
            {{ utils.giveMessageError('INVALID_CONTAINER_GENERAL') }}
        </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-12" *ngIf="internalForm.get('chapterControl').value">
        <mat-label>Capítulo <span class="asterisk">*</span></mat-label>
        <input matInput [formControl]="internalForm.get('chapterControl')">
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-12"
        *ngIf="consignmentManager.consignmentRequiresDescription(form.getRawValue())">
        <mat-label>Descripción de la mercancía<span class="asterisk">*</span></mat-label>
        <input matInput [formControl]="form.get('productDescription')">
        <mat-error *ngIf="form.get('productDescription')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
        <mat-error *ngIf="form.get('productDescription')?.errors?.maxlength">
            {{ utils.giveMessageError('MAX_LENGTH_EXCEEDED', 'Descripción de la mercancía', 60) }}
        </mat-error>
    </mat-form-field>
    <app-cargo-type-dangerous-merchandise [inputFormControl]="internalForm.get('subHeaderControl')"
        *ngIf="form.get('requiresSubSection')?.value" [options]="{ 
            appearance: 'outline', 
            title:'Subpartida', 
            typeMerchandise: getCode('SUBHEADER'), 
            code: form.get('merchandise.code')?.value,
            selectionType: 'select',
            initialTypeMerchandiseToSearch: initialValues.subSection
        }" [validate]="hasEntryId() ? 'disable' : formValidate" class="col-md-6"
        [ngClass]="{'col-md-12': !form.get('requiresTaxCode')?.value}">
    </app-cargo-type-dangerous-merchandise>
    <app-cargo-type-dangerous-merchandise [inputFormControl]="internalForm.get('tariffControl')"
        *ngIf="form.get('requiresTaxCode')?.value && internalForm.get('subHeaderControl')?.value" [options]="{ 
            appearance: 'outline', 
            title:'Arancel', 
            typeMerchandise: getCode('TARIFF'), 
            code: internalForm.get('subHeaderControl')?.value?.code + internalForm.get('subHeaderControl')?.value?.subSectionCode,
            selectionType: 'select',
            initialTypeMerchandise: initialValues.tax
        }" [validate]="hasEntryId() ? 'disable' : formValidate" class="col-md-6">
    </app-cargo-type-dangerous-merchandise>
    <div class="col-12 mb-4" *ngIf="isDangerous">
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title class="text-strong">
                    <i *ngIf="!consignmentManager.getCompleteDangerousFields(form.getRawValue()).valid"
                        class="fa fa-exclamation-triangle warning-text mr-2" aria-hidden="true"></i>
                    <i *ngIf="consignmentManager.getCompleteDangerousFields(form.getRawValue()).valid"
                        class="fas fa-check-circle success-text mr-2" aria-hidden="true"></i>
                    Mercancías peligrosas
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="d-flex flex-row flex-wrap">
                <p class="col-12 text-bold text-center alert alert-warning" role="alert"
                    *ngIf="!consignmentManager.getCompleteDangerousFields(form.getRawValue()).valid">
                    {{ consignmentManager.getCompleteDangerousFields(form.getRawValue()).error }}
                </p>
                <app-cargo-type-dangerous-merchandise [inputFormControl]="internalForm.get('UNCodeControl')" [options]="{ 
                        appearance: 'outline', 
                        title:'Código UN', 
                        typeMerchandise: getCode('UN_CODE'),
                        initialTypeMerchandiseToSearch: initialValues.unProduct
                    }" [validate]="formValidate" class="col-md-4">
                </app-cargo-type-dangerous-merchandise>
                <mat-form-field appearance="outline" class="col-md-8">
                    <mat-label>Designación mercancía peligrosa<span class="asterisk">*</span></mat-label>
                    <input matInput [formControl]="internalForm.get('UNDescriptionControl')">
                    <mat-error *ngIf="internalForm.get('UNDescriptionControl')?.errors?.required">
                        {{ utils.giveMessageError('MANDATORY_FIELD') }}
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="col-md-6">
                    <mat-label>Estado del producto<span class="asterisk">*</span></mat-label>
                    <mat-select [formControl]="internalForm.get('productTypeStateControl')"
                        [compareWith]="compareByCode" (selectionChange)="onChangeProductTypeState($event.value)">
                        <mat-option *ngFor="let option of productTypeStates" [value]="option">
                            ({{ option.code }}) {{ option.label }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="internalForm.get('productTypeStateControl')?.errors?.required">
                        {{ utils.giveMessageError('MANDATORY_FIELD') }}
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="col-md-6"
                    *ngIf="form.get('dangerousMerchandise.hasPackaging')?.value">
                    <mat-label>Grupo de embalaje<span class="asterisk">*</span></mat-label>
                    <mat-select [formControl]="internalForm.get('packagingGroupControl')" [compareWith]="compareByCode"
                        (selectionChange)="onChangePackagingGroup($event.value)">
                        <mat-option *ngFor="let option of packagingGroupOptions" [value]="option">
                            {{ option.code }} - {{ option.description }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="internalForm.get('packagingGroupControl')?.errors?.required">
                        {{ utils.giveMessageError('MANDATORY_FIELD') }}
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="col-md-6"
                    *ngIf="internalForm.get('UNDescriptionControl').value?.includes('N.E.P.')">
                    <mat-label>Grupo químico N.E.P.<span class="asterisk">*</span></mat-label>
                    <input matInput [formControl]="form.get('dangerousMerchandise.nepName')">
                    <mat-error *ngIf="form.get('dangerousMerchandise.nepName')?.errors?.required">
                        {{ utils.giveMessageError('MANDATORY_FIELD') }}
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="col-md-6"
                    *ngIf="isHazardous && form.get('hazardousWaste.hazardousWasteDescription')">
                    <mat-label>Descripción residuo peligroso<span class="asterisk">*</span></mat-label>
                    <input matInput [formControl]="form.get('hazardousWaste.hazardousWasteDescription')">
                    <mat-error *ngIf="form.get('hazardousWaste.hazardousWasteDescription')?.errors?.required">
                        {{ utils.giveMessageError('MANDATORY_FIELD') }}
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="col-md-6"
                    *ngIf="isHazardous && form.get('hazardousWaste.hazardLevel')">
                    <mat-label>Característica de peligrosidad<span class="asterisk">*</span></mat-label>
                    <mat-select [formControl]="form.get('hazardousWaste.hazardLevel')" [compareWith]="compareByCode">
                        <mat-option *ngFor="let option of dangerousCharacteristicsOptions" [value]="option">
                            {{ option.description }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('hazardousWaste.hazardLevel')?.errors?.required">
                        {{ utils.giveMessageError('MANDATORY_FIELD') }}
                    </mat-error>
                </mat-form-field>
                <div class="col-12 d-flex flex-row flex-wrap px-0" *ngIf="isHazardous">
                    <label class="col-12 text-bold">Corrientes de Residuos Peligrosos<span
                            class="asterisk">*</span></label>
                    <mat-form-field appearance="outline" class="col-md-4">
                        <mat-select [formControl]="internalForm.get('hazardousWasteCurrentControl')"
                            (selectionChange)="onChangeHazardousWasteCurrent()">
                            <mat-option *ngFor="let option of hazardousWasteCurrentOptions" [value]="option">
                                {{ option }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="internalForm.get('hazardousWasteCurrentControl')?.errors?.required">
                            {{ utils.giveMessageError('MANDATORY_FIELD') }}
                        </mat-error>
                    </mat-form-field>
                    <app-cargo-type-dangerous-merchandise
                        [inputFormControl]="internalForm.get('hazardousWasteCurrentDescriptionControl')" [options]="{ 
                            appearance: 'outline', 
                            title:'', typeMerchandise: getCode('HAZARDOUS_WASTE'), 
                            hazardousType: internalForm.get('hazardousWasteCurrentControl')?.value,
                            initialTypeMerchandiseToSearch: initialValues.waste
                         }" [validate]="formValidate" class="col-md-8">
                    </app-cargo-type-dangerous-merchandise>
                </div>
                <app-cargo-type-dangerous-merchandise [inputFormControl]="internalForm.get('disintegrationControl')"
                    [options]="{ 
                        appearance: 'outline', 
                        title:'Desagregación', 
                        typeMerchandise: getCode('DISAGREGATION'), 
                        code: form.get('hazardousWaste.waste')?.value?.code,
                        selectionType: 'select',
                        initialTypeMerchandise: initialValues.wasteDisaggregation
                    }" [validate]="formValidate" class="col-md-6"
                    *ngIf="form.get('hazardousWaste.hasWasteDisaggregation')?.value && form.get('hazardousWaste.waste')?.value?.code">
                </app-cargo-type-dangerous-merchandise>
            </div>
        </mat-expansion-panel>
    </div>

    <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Cantidad cargada<span class="asterisk">*</span></mat-label>
        <input matInput currencyMask type="text" onlyNumbersInt min="0" [secureZero]="false"
            formControlName="totalWeight">
        <mat-error *ngIf="form.get('totalWeight')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
        <mat-error *ngIf="form.get('totalWeight')?.errors?.min">
            {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'cantidad cargada', 0) }}
        </mat-error>
    </mat-form-field>
    <div class="col-md-6">
        <mat-label class="text-bold">Unidad medida de transporte<span class="asterisk">*</span></mat-label>
        <mat-radio-group aria-label="Select an option" formControlName="weightUnit">
            <mat-radio-button value="1">Kilos</mat-radio-button>
        </mat-radio-group>
    </div>
    <mat-form-field appearance="outline" class="col-md-6"
        *ngIf="consignmentManager.consignmentRequiresAmountProduct(form.getRawValue())">
        <mat-label>Cantidad de medida del producto
            <span class="asterisk">*</span>
        </mat-label>
        <input matInput currencyMask type="text" onlyNumbersInt min="0"
            [formControl]="internalForm.get('totalWeightControl')" [secureZero]="false">
        <mat-error *ngIf="internalForm.get('totalWeightControl')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
        <mat-error *ngIf="internalForm.get('totalWeightControl')?.errors?.min">
            {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'cantidad de medida del producto', 0) }}
        </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-6"
        *ngIf="consignmentManager.consignmentRequiresAmountProduct(form.getRawValue())">
        <mat-label>Unidad medida del producto
            <span class="asterisk">*</span>
        </mat-label>
        <mat-select [formControl]="internalForm.get('weightUnitControl')"
            (selectionChange)="onChangeWeightUnit($event.value)" [compareWith]="compareByCode">
            <mat-option *ngFor="let weightUnit of weightUnitOptions" [value]="weightUnit">
                {{ weightUnit.description }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="internalForm.get('weightUnitControl')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
    </mat-form-field>

    <p class="col-12 text-bold site-title">Sitio de cargue</p>
    <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Ciudad <span class="asterisk">*</span></mat-label>
        <mat-select (selectionChange)="onChangeCity($event.value, 'sender')"
            [formControl]="internalForm.get('senderCityControl')" [compareWith]="compareByKey">
            <mat-option *ngFor="let option of senderCityOptions | keyvalue; let j = index" [value]="option"
                [disabled]="!!isDisabledCity(option?.key, option?.value)"
                [matTooltip]="isDisabledCity(option?.key, option?.value)" matTooltipClass="tooltip__error"
                matTooltipPosition="right">
                {{ option?.key? option?.key : 'Ciudad no diligenciada' }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="internalForm.get('senderCityControl')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Remitente <span class="asterisk">*</span></mat-label>
        <mat-select (selectionChange)="onChangeThirdParty($event.value, 'sender')"
            [formControl]="internalForm.get('senderThirdParty')">
            <mat-option
                *ngFor="let option of internalForm.get('senderCityControl')?.value?.value?.thirdParties; let j = index"
                [value]="option" [disabled]="!!isDisabledThirdParty(option)" [matTooltip]="isDisabledThirdParty(option)"
                matTooltipClass="tooltip__error" matTooltipPosition="right">
                {{ option?.name ? option?.name : 'Remitente no diligenciado' }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="internalForm.get('senderThirdParty')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-12">
        <mat-label>Dirección <span class="asterisk">*</span></mat-label>
        <mat-select (selectionChange)="onChangeAddress($event.value, 'sender')"
            [formControl]="internalForm.get('senderAddressControl')">
            <mat-option *ngFor="let option of internalForm.get('senderThirdParty')?.value?.addresses; let j = index"
                [value]="option" [disabled]="!!isDisabledAddress(option?.address, option)"
                [matTooltip]="isDisabledAddress(option?.address, option)" matTooltipClass="tooltip__error"
                matTooltipPosition="right">
                {{ j + 1 }}. {{ option?.address? option?.address : 'Dirección no diligenciada' }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="internalForm.get('senderAddressControl')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
    </mat-form-field>
    <app-geo-validation-feedback class="col-12" [validating]="senderGeoValidating" [error]="senderGeoError"
        [showEditButton]="true" (editAddress)="editGeoAddress('sender')">
    </app-geo-validation-feedback>
    <mat-form-field class="col-md-6" appearance="outline">
        <mat-label>Tiempo pactado<span class="asterisk">*</span></mat-label>
        <mat-select [formControl]="internalForm.get('loadTimePactControl')" [compareWith]="compareTimePact"
            (selectionChange)="onChangeTimePact($event.value, 'load')">
            <mat-option *ngFor="let option of loadTimePactOptions" [value]="option">
                {{ option.description }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="internalForm.get('loadTimePactControl')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
    </mat-form-field>
    <div class="col-md-6">
        <p role="alert" class="alert alert-warning text-bold d-flex align-items-center justify-content-center">
            Esta dirección de cargue será enviada al RNDC.
        </p>
    </div>

    <p class="col-12 text-bold site-title">Sitio de descargue</p>
    <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Ciudad <span class="asterisk">*</span></mat-label>
        <mat-select (selectionChange)="onChangeCity($event.value, 'recipient')"
            [formControl]="internalForm.get('recipientCityControl')" [compareWith]="compareByKey">
            <mat-option *ngFor="let option of recipientCityOptions | keyvalue; let j = index" [value]="option"
                [disabled]="!!isDisabledCity(option?.key, option?.value)"
                [matTooltip]="isDisabledCity(option?.key, option?.value)" matTooltipClass="tooltip__error"
                matTooltipPosition="right">
                {{ option?.key? option?.key : 'Ciudad no diligenciada' }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="internalForm.get('recipientCityControl')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Destinatario <span class="asterisk">*</span></mat-label>
        <mat-select (selectionChange)="onChangeThirdParty($event.value, 'recipient')"
            [formControl]="internalForm.get('recipientThirdParty')">
            <mat-option
                *ngFor="let option of internalForm.get('recipientCityControl')?.value?.value?.thirdParties; let j = index"
                [value]="option" [disabled]="!!isDisabledThirdParty(option)" [matTooltip]="isDisabledThirdParty(option)"
                matTooltipClass="tooltip__error" matTooltipPosition="right">
                {{ option?.name ? option?.name : 'Destinatario no diligenciado' }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="internalForm.get('recipientThirdParty')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-12">
        <mat-label>Dirección <span class="asterisk">*</span></mat-label>
        <mat-select (selectionChange)="onChangeAddress($event.value, 'recipient')"
            [formControl]="internalForm.get('recipientAddressControl')">
            <mat-option *ngFor="let option of internalForm.get('recipientThirdParty')?.value?.addresses; let j = index"
                [value]="option" [disabled]="!!isDisabledAddress(option?.address, option)"
                [matTooltip]="isDisabledAddress(option?.address, option)" matTooltipClass="tooltip__error"
                matTooltipPosition="right">
                {{ j + 1 }}. {{ option?.address? option?.address : 'Dirección no diligenciada' }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="internalForm.get('recipientAddressControl')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
    </mat-form-field>
    <app-geo-validation-feedback class="col-12" [validating]="recipientGeoValidating" [error]="recipientGeoError"
        [showEditButton]="true" (editAddress)="editGeoAddress('recipient')">
    </app-geo-validation-feedback>
    <mat-form-field class="col-md-6" appearance="outline">
        <mat-label>Tiempo pactado<span class="asterisk">*</span></mat-label>
        <mat-select [formControl]="internalForm.get('unloadTimePactControl')" [compareWith]="compareTimePact"
            (selectionChange)="onChangeTimePact($event.value, 'unload')">
            <mat-option *ngFor="let option of unloadTimePactOptions" [value]="option">
                {{ option.description }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="internalForm.get('unloadTimePactControl')?.errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
    </mat-form-field>
    <div class="col-md-6">
        <p role="alert" class="alert alert-warning text-bold d-flex align-items-center justify-content-center">
            Esta dirección de descargue será enviada al RNDC.
        </p>
    </div>
</form>